<template>
  <div>
    <!-- <el-dialog
      id="translate-modal2"
      class="sm-width-90 cust-head"
      size="sm"
      title="Translate site"
      width="31%"
      :visible.sync="isShowTranslater"
    >
     
      <v-google-translate
        defaultLanguageCode="en"
        defaultPageLanguageCode="en"
        fetchBrowserLanguage="false"
        :languages="languages"
      />
    </el-dialog> -->
    <el-drawer
      class="cust-drawer space-tb mob-nav-width tab-nav-width"
      size="20%"
      title="I am the title"
      :visible.sync="isShowMenu"
      :with-header="false"
      rtl
    >
      <span>
        <div class="menuitems px-5">
          <img
            :src="
              primaryLogo
                ? primaryLogo
                : 'https://nimbuscluster.blob.core.windows.net/server01/eurobond/all-in-one/navlogo.webp'
            "
            icon="logo"
            alt="logo"
            class="w-full"
          />
        </div>

        <div class="lg:w-full md:w-full mt-10">
          <vs-navbar-item
            v-for="(item, index) in menuData"
            :key="'item' + index"
          >
            <a
              v-if="item.menutype === 'page' && item.subMenu.length < 2"
              @click="handleclick(item.pageData[0].page)"
              class="font-semibold px-5 cust-border-bottom fsize14 text-3535 cust-active-bg cursor-pointer"
              :class="{
                'text-blue font-semibold':
                  selectedRoute.name === item.pageData[0].page,
              }"
              >{{ item.menuName }}
            </a>
            <a
              v-else-if="item.menutype === 'url'"
              :href="item.menuData"
              class="font-semibold px-5 lg:mb-1 md:mb-1 fsize14 text-3535 cust-active-bg cursor-pointer"
              >{{ item.menuName }}
            </a>
            <div v-if="item.menutype === 'page' && item.subMenu.length > 1">
              <el-collapse
                class="navfontsize brnone"
                v-model="activeNamesAbout"
                accordion
              >
                <!-- @change="handleChange" -->
                <el-collapse-item
                  :title="item.menuName"
                  class="fontsize cust-bg-none fontpx-5 brdnone"
                >
                  <div
                    v-for="(sub, index) in item.subMenu"
                    :key="'item' + index"
                    aria-sort="ascending"
                    class="font-semibold px-5 lg:mr-8 md:mr-8 lg:mb-3 md:mb-3 mb-2 pt-2 fsize12 cust-font-hover text-3535 cursor-pointer"
                  >
                    <p
                      @click="handleClick(sub.pageData[0].page)"
                      v-if="sub.menutype === 'page'"
                    >
                      {{ sub.menuName }}
                    </p>

                    <a
                      target="_blank"
                      v-else-if="sub.menutype === 'url'"
                      :href="sub.menuData"
                      class="fixanchr lg:mb-1 md:mb-1 fsize14 text-3535 cust-active-bg cursor-pointer"
                      >{{ sub.menuName }}
                    </a>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>

            <!-- <el-collapse
              class="wrap-bgcolor px-1 ml-1 navfontsize"
              v-model="activeProduct"
              @change="handleChange"
            >
              <el-collapse-item title="Product" name="1" class="ml-1">
                <div
                  class="font-semibold lg:mr-8 md:mr-8 lg:mb-3 md:mb-3 fsize12 text-b8b8b8 cursor-pointer"
                  @click="handleClick('Product')"
                >
                  ACP
                </div>
                <div
                  class="font-semibold lg:mr-8 md:mr-8 lg:mb-3 md:mb-3 fsize12 text-b8b8b8 cursor-pointer"
                  @click="handleClick('product-categories')"
                >
                  AHPL
                </div>
                <div
                  class="font-semibold lg:mr-8 md:mr-8 lg:mt-3 md:mt-3 lg:mb-3 md:mb-3 lg:mb-3 md:mb-3 fsize12 text-b8b8b8 cursor-pointer"
                  @click="handleClick('acp')"
                >
                  FR ACP
                </div>
                <div
                  class="font-semibold lg:mr-8 md:mr-8 lg:mt-3 md:mt-3 lg:mb-3 md:mb-3 fsize12 text-b8b8b8 cursor-pointer"
                  @click="handleClick('honey-pannel')"
                >
                  Aluminium Honey Panel
                </div>
              </el-collapse-item>
            </el-collapse> -->
          </vs-navbar-item>
          <!-- <a
            class="font-semibold px-5 cust-border-bottom lg:mt-0 md:mt-0 lg:mb-2 md:mb-2 fsize14 cust-active-bg text-3535 cursor-pointer"
            @click="handleClick('product-designs')"
            >Product Design
          </a>

          <a
            @click="handleClick('project')"
            class="font-semibold px-5 lg:mt-0 md:mt-0 fsize14 cust-active-bg text-3535 cursor-pointer"
            >Project
          </a> -->
          <!-- cust-bg-ff9137 -->
          <!-- <a
              class="mt-2 mt-2 px-5 cust-border-bottom border-0 font-semibold flex justify-center text-3535 cust-active-bg cust-hover-none cursor-pointer"
              @click="handleClick('download-catalogues')"
              >Download Catalogue</a
            > -->

          <!-- <el-collapse
            class="navfontsize"
            v-model="activeProduct"
            @change="handleChange"
          >
            <el-collapse-item
              title="More/Media"
              name="1"
              class="fontsize cust-bg-none fontpx-5"
            >
              <div
                class="font-semibold px-5 pt-2 lg:mb-3 cust-font-hover md:mb-3 mb-1 fsize12 text-3535 cursor-pointer"
                @click="handleClick('design-support')"
              >
                Design Support
              </div>
              <div
                class="font-semibold px-5 lg:mb-3 md:mb-3 cust-font-hover mb-1 fsize12 text-3535 cursor-pointer"
                @click="handleClick('events')"
              >
                @click="handleClick('events')"
                News &amp; Events
              </div>
              <div
                class="font-semibold px-5 lg:mt-3 md:mt-3 lg:mb-3 cust-font-hover md:mb-3 mb-1 fsize12 text-3535 cursor-pointer"
                @click="handleClick('blogs')"
              >
                @click="handleClick('blogs')"
                Blog
              </div>
              <div
                class="font-semibold px-5 lg:mt-3 md:mt-3 lg:mb-3 cust-font-hover md:mb-3 mb-1 fsize12 text-3535 cursor-pointer"
                @click="handleClick('careers')"
              >
                Careers
              </div>
            </el-collapse-item>
          </el-collapse> -->

          <!-- <a
            @click="handleClick('investor-relations')"
            class="font-semibold cust-border-bottom px-5 lg:mt-0 md:mt-0 lg:mb-2 md:mb-2 fsize14 cust-active-bg text-3535 cursor-pointer"
            >Investor Relations
          </a> -->
          <!-- <a
              @click="handleClick('blogs')"
              class="
                font-semibold
                lg:mr-8
                md:mr-8
                    lg:mt-3
                    md:mt-3
                    lg:mb-3
                    md:mb-3
                fsize14
                text-white
                cursor-pointer
              "
              >Blog
            </a>  <a
              @click="handleClick('events')"
              class="font-semibold lg:mr-8 md:mr-8 lg:mt-1 md:mt-1 lg:mb-3 md:mb-3 fsize14 text-white cursor-pointer"
              >Events
            </a>
            <a
              @click="handleClick('career')"
              class="font-semibold lg:mr-8 md:mr-8 lg:mt-1 md:mt-1 lg:mb-3 md:mb-3 fsize14 text-white cursor-pointer"
              >Career
            </a>
            -->
          <!-- 
          <a
            @click="handleClick('contact')"
            class="font-semibold cust-border-bottom px-5 lg:mt-0 md:mt-0 lg:mb-2 md:mb-2 fsize14 cust-active-bg text-3535 cursor-pointer"
            >Contact
          </a> -->
          <div class="justify-center flex">
            <vs-button
              color="primary"
              class="lg:mt-8 md:mt-8 mt-6 lg:px-8 md:px-8 px-4"
              @click="handleClick('download-catalogues')"
            >
              Download Catalogue</vs-button
            >
          </div>
          <div class="justify-center flex lg:mt-8 md:mt-6 mt-4">
            <p
              class="font-semibold px-5 lg:mb-4 md:mb-4 mb-2 fsize16 cust-active-bg textsecondary"
            >
              Follow Us
            </p>
          </div>
          <div class="flex items-center justify-center">
            <a
              aria-label="icon"
              href="https://instagram.com/eurobond_acp?igshid=YmMyMTA2M2Y="
              target="_blank"
              class="icon-bdr"
            >
              <feather-icon
                icon="InstagramIcon"
                class="textsecondary cursor-pointer"
            /></a>
            <a
              href="https://youtube.com/@EurobondMumbai"
              target="_blank"
              aria-label="icon"
              class="icon-bdr"
              ><feather-icon
                icon="YoutubeIcon"
                class="textsecondary cursor-pointer"
            /></a>
            <a
              aria-label="icon"
              href="https://www.linkedin.com/company/eurobond-acp"
              target="_blank"
              class="icon-bdr"
              ><feather-icon
                icon="LinkedinIcon"
                class="textsecondary cursor-pointer"
            /></a>
            <a
              aria-label="icon"
              href="https://www.facebook.com/eurobondacppanel?mibextid=LQQJ4d"
              target="_blank"
              class="icon-bdr"
              ><feather-icon
                icon="FacebookIcon"
                class="textsecondary cursor-pointer"
            /></a>
          </div>
        </div>
      </span>
    </el-drawer>

    <vs-navbar
      v-model="activeItem"
      ref="navbarRef"
      class="nabarx lg:py-4 z-10 md:py-3 bg-white lg:px-16 md:px-16 px-0 py-0 fixed z-i999 z-i999"
    >
      <div
        slot="title"
        class="flex justify-between items-center lg:p-0 md:p-0 p-4 w-full"
      >
        <vs-navbar-title>
          <img
            :src="
              primaryLogo
                ? primaryLogo
                : 'https://nimbuscluster.blob.core.windows.net/server01/eurobond/all-in-one/navlogo.webp'
            "
            icon="logo"
            class="navbar_logo cursor-pointer object-contain"
            @click="handleClick('Home')"
            alt="logo"
        /></vs-navbar-title>
        <div class="flex md:gap-6 gap-4 items-center">
          <a href="tel:+91 7045453724" class="lg:hidden block">
            <feather-icon icon="PhoneIcon" svgClasses="w-5 h-5"
          /></a>
          <!-- <div class="flex items-center">
            <div class="md:pr-3 lg:px-3 px-1 block cursor-pointer">
              <img
                src="../assets/images/translation.png"
                class="lg:hidden mx-auto"
                alt="img"
              />
            </div>
            <div class="">
              <v-google-translate
                defaultLanguageCode="en"
                defaultPageLanguageCode="en"
                fetchBrowserLanguage="false"
                :languages="languages"
                class="nav-cust lg:hidden"
              />
            </div>
          </div> -->
          <div class="lg:pr-8 lg:hidden block cursor-pointer">
            <div class="hovermenu" @click="isShowMenu = true">
              <MenuIcon size="1.5x" class="custom-class" />
            </div>
          </div>
        </div>
      </div>

      <!-- <div
      class="lg:flex md:flex zindex_1 justify-center left-0 lg:absolute md:absolute lg:w-full md:w-full items-center"
    >
      <vs-navbar-item
        index="0"
        v-for="(item, index) in menu"
        :key="'item-' + index"
      >
        <a
          @click="handleclick(item.route)"
          class="font-semibold mr-8 fsize14 cursor-pointer"
          :class="{
            'textprimary font-bold': !!item.isActive,
            '': !item.isActive,
          }"
          >{{ item.name }}</a
        >
      </vs-navbar-item>
    </div> -->

      <!-- language popup -->
      <!-- <div class="md:px-3 lg:px-3 px-1 block cursor-pointer">
        <img
          @click="handleOpenTranslator"
          src="../assets/images/translation.png"
          class="mx-auto"
          alt="img"
        />
      </div> -->

      <div id="google_translate_element" class="wid-google mx-2"></div>
      <!-- @click="handleOpenTranslator" -->
      <!-- <div class="px-1 block">
        <img src="../assets/images/translation.png" class="mx-auto" alt="img" />
      </div>
      <div class="pr-6">
        <v-google-translate
          defaultLanguageCode="en"
          defaultPageLanguageCode="en"
          fetchBrowserLanguage="false"
          :languages="languages"
          class="nav-cust"
        />
      </div> -->
      <div class="pr-6">
        <a href="tel:+91 7045453724">
          <vs-button color="secondary" class="py-2 fsize14 rounded-full"
            >+91 7045453724</vs-button
          >
        </a>
      </div>
      <div class="lg:pr-8 lg:block md:block">
        <div class="hovermenu cursor-pointer" @click="isShowMenu = true">
          <MenuIcon size="1.5x" class="custom-class" />
        </div>
      </div>
    </vs-navbar>
  </div>
</template>
<script>
import { MenuIcon } from "vue-feather-icons";
import CGTranslator from "../plugins/GoogleTranslator.vue";
// import languageJson from "./language.json";
import Translator from "vue-gtranslate";
import { mapState } from "vuex";
export default {
  data: () => ({
    activeItem: 0,
    activeNames: ["0"],
    activeProduct: ["0"],
    activeNamesAbout: ["0"],
    activeProductManufacturing: ["0"],
    isShowMenu: false,
    getBrandProfileData: "",
    isShowTranslater: false,

    getMenu: [],
    subMenu: [],
    countries: [
      {
        code: "en|hi",
        title: "हिन्दी",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
        altText: "Hindi language translation",
      },
      {
        code: "en|bn",
        title: "বাংলা",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
        altText: "Bengali language translation",
      },
      {
        code: "en|te",
        title: "తెలుగు",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
        altText: "Telugu language translation",
      },
      {
        code: "en|mr",
        title: "मराठी",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
        altText: "Marathi language translation",
      },

      {
        code: "en|en",
        title: "English",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
        altText: "English language translation",
      },
      {
        code: "ru",
        title: "Русский",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/ru.svg",
      },
      {
        code: "pt",
        title: "Português",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/pt.svg",
      },
      {
        code: "de",
        title: "Deutsch",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/de.svg",
      },
      {
        code: "ja",
        title: "日本語",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/jp.svg",
      },
      {
        code: "ko",
        title: "한국어",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/kr.svg",
      },
    ],
    languages: [
      { code: "ab", name: "Abkhaz", ename: "аҧсуа" },
      { code: "aa", name: "Afar", ename: "Afaraf" },
      { code: "af", name: "Afrikaans", ename: "Afrikaans" },
      { code: "ak", name: "Akan", ename: "Akan" },
      { code: "sq", name: "Albanian", ename: "Shqip" },
      { code: "am", name: "Amharic", ename: "አማርኛ" },
      { code: "ar", name: "Arabic", ename: "العربية" },
      { code: "an", name: "Aragonese", ename: "Aragonés" },
      { code: "hy", name: "Armenian", ename: "Հայերեն" },
      { code: "as", name: "Assamese", ename: "অসমীয়া" },
      { code: "av", name: "Avaric", ename: "авар мацӀ, магӀарул мацӀ" },
      { code: "ae", name: "Avestan", ename: "avesta" },
      { code: "ay", name: "Aymara", ename: "aymar aru" },
      { code: "az", name: "Azerbaijani", ename: "azərbaycan dili" },
      { code: "bm", name: "Bambara", ename: "bamanankan" },
      { code: "ba", name: "Bashkir", ename: "башҡорт теле" },
      { code: "eu", name: "Basque", ename: "euskara, euskera" },
      { code: "be", name: "Belarusian", ename: "Беларуская" },
      { code: "bn", name: "Bengali", ename: "বাংলা" },
      { code: "bh", name: "Bihari", ename: "भोजपुरी" },
      { code: "bi", name: "Bislama", ename: "Bislama" },
      { code: "bs", name: "Bosnian", ename: "bosanski jezik" },
      { code: "br", name: "Breton", ename: "brezhoneg" },
      { code: "bg", name: "Bulgarian", ename: "български език" },
      { code: "my", name: "Burmese", ename: "ဗမာစာ" },
      { code: "ca", name: "Catalan; Valencian", ename: "Català" },
      { code: "ch", name: "Chamorro", ename: "Chamoru" },
      { code: "ce", name: "Chechen", ename: "нохчийн мотт" },
      {
        code: "ny",
        name: "Chichewa; Chewa; Nyanja",
        ename: "chiCheŵa, chinyanja",
      },
      { code: "zh", name: "Chinese", ename: "中文 (Zhōngwén), 汉语, 漢語" },
      { code: "cv", name: "Chuvash", ename: "чӑваш чӗлхи" },
      { code: "kw", name: "Cornish", ename: "Kernewek" },
      { code: "co", name: "Corsican", ename: "corsu, lingua corsa" },
      { code: "cr", name: "Cree", ename: "ᓀᐦᐃᔭᐍᐏᐣ" },
      { code: "hr", name: "Croatian", ename: "hrvatski" },
      { code: "cs", name: "Czech", ename: "česky, čeština" },
      { code: "da", name: "Danish", ename: "dansk" },
      { code: "dv", name: "Divehi; Dhivehi; Maldivian;", ename: "ދިވެހި" },
      { code: "nl", name: "Dutch", ename: "Nederlands, Vlaams" },
      { code: "en", name: "English", ename: "English" },
      { code: "eo", name: "Esperanto", ename: "Esperanto" },
      { code: "et", name: "Estonian", ename: "eesti, eesti keel" },
      { code: "ee", name: "Ewe", ename: "Eʋegbe" },
      { code: "fo", name: "Faroese", ename: "føroyskt" },
      { code: "fj", name: "Fijian", ename: "vosa Vakaviti" },
      { code: "fi", name: "Finnish", ename: "suomi, suomen kieli" },
      { code: "fr", name: "French", ename: "français, langue française" },
      {
        code: "ff",
        name: "Fula; Fulah; Pulaar; Pular",
        ename: "Fulfulde, Pulaar, Pular",
      },
      { code: "gl", name: "Galician", ename: "Galego" },
      { code: "ka", name: "Georgian", ename: "ქართული" },
      { code: "de", name: "German", ename: "Deutsch" },
      { code: "el", name: "Greek, Modern", ename: "Ελληνικά" },
      { code: "gn", name: "Guaraní", ename: "Avañeẽ" },
      { code: "gu", name: "Gujarati", ename: "ગુજરાતી" },
      { code: "ht", name: "Haitian; Haitian Creole", ename: "Kreyòl ayisyen" },
      { code: "ha", name: "Hausa", ename: "Hausa, هَوُسَ" },
      { code: "he", name: "Hebrew (modern)", ename: "עברית" },
      { code: "hz", name: "Herero", ename: "Otjiherero" },
      { code: "hi", name: "Hindi", ename: "हिन्दी, हिंदी" },
      { code: "ho", name: "Hiri Motu", ename: "Hiri Motu" },
      { code: "hu", name: "Hungarian", ename: "Magyar" },
      { code: "ia", name: "Interlingua", ename: "Interlingua" },
      { code: "id", name: "Indonesian", ename: "Bahasa Indonesia" },
      {
        code: "ie",
        name: "Interlingue",
        ename: "Originally called Occidental; then Interlingue after WWII",
      },
      { code: "ga", name: "Irish", ename: "Gaeilge" },
      { code: "ig", name: "Igbo", ename: "Asụsụ Igbo" },
      { code: "ik", name: "Inupiaq", ename: "Iñupiaq, Iñupiatun" },
      { code: "io", name: "Ido", ename: "Ido" },
      { code: "is", name: "Icelandic", ename: "Íslenska" },
      { code: "it", name: "Italian", ename: "Italiano" },
      { code: "iu", name: "Inuktitut", ename: "ᐃᓄᒃᑎᑐᑦ" },
      { code: "ja", name: "Japanese", ename: "日本語 (にほんご／にっぽんご)" },
      { code: "jv", name: "Javanese", ename: "basa Jawa" },
      {
        code: "kl",
        name: "Kalaallisut, Greenlandic",
        ename: "kalaallisut, kalaallit oqaasii",
      },
      { code: "kn", name: "Kannada", ename: "ಕನ್ನಡ" },
      { code: "kr", name: "Kanuri", ename: "Kanuri" },
      { code: "ks", name: "Kashmiri", ename: "कश्मीरी, كشميري‎" },
      { code: "kk", name: "Kazakh", ename: "Қазақ тілі" },
      { code: "km", name: "Khmer", ename: "ភាសាខ្មែរ" },
      { code: "ki", name: "Kikuyu, Gikuyu", ename: "Gĩkũyũ" },
      { code: "rw", name: "Kinyarwanda", ename: "Ikinyarwanda" },
      { code: "ky", name: "Kirghiz, Kyrgyz", ename: "кыргыз тили" },
      { code: "kv", name: "Komi", ename: "коми кыв" },
      { code: "kg", name: "Kongo", ename: "KiKongo" },
      { code: "ko", name: "Korean", ename: "한국어 (韓國語), 조선말 (朝鮮語)" },
      { code: "ku", name: "Kurdish", ename: "Kurdî, كوردی‎" },
      { code: "kj", name: "Kwanyama, Kuanyama", ename: "Kuanyama" },
      { code: "la", name: "Latin", ename: "latine, lingua latina" },
      {
        code: "lb",
        name: "Luxembourgish, Letzeburgesch",
        ename: "Lëtzebuergesch",
      },
      { code: "lg", name: "Luganda", ename: "Luganda" },
      {
        code: "li",
        name: "Limburgish, Limburgan, Limburger",
        ename: "Limburgs",
      },
      { code: "ln", name: "Lingala", ename: "Lingála" },
      { code: "lo", name: "Lao", ename: "ພາສາລາວ" },
      { code: "lt", name: "Lithuanian", ename: "lietuvių kalba" },
      { code: "lu", name: "Luba-Katanga", ename: "" },
      { code: "lv", name: "Latvian", ename: "latviešu valoda" },
      { code: "gv", name: "Manx", ename: "Gaelg, Gailck" },
      { code: "mk", name: "Macedonian", ename: "македонски јазик" },
      { code: "mg", name: "Malagasy", ename: "Malagasy fiteny" },
      { code: "ms", name: "Malay", ename: "bahasa Melayu, بهاس ملايو‎" },
      { code: "ml", name: "Malayalam", ename: "മലയാളം" },
      { code: "mt", name: "Maltese", ename: "Malti" },
      { code: "mi", name: "Māori", ename: "te reo Māori" },
      { code: "mr", name: "Marathi (Marāṭhī)", ename: "मराठी" },
      { code: "mh", name: "Marshallese", ename: "Kajin M̧ajeļ" },
      { code: "mn", name: "Mongolian", ename: "монгол" },
      { code: "na", name: "Nauru", ename: "Ekakairũ Naoero" },
      { code: "nv", name: "Navajo, Navaho", ename: "Diné bizaad, Dinékʼehǰí" },
      { code: "nb", name: "Norwegian Bokmål", ename: "Norsk bokmål" },
      { code: "nd", name: "North Ndebele", ename: "isiNdebele" },
      { code: "ne", name: "Nepali", ename: "नेपाली" },
      { code: "ng", name: "Ndonga", ename: "Owambo" },
      { code: "nn", name: "Norwegian Nynorsk", ename: "Norsk nynorsk" },
      { code: "no", name: "Norwegian", ename: "Norsk" },
      { code: "ii", name: "Nuosu", ename: "ꆈꌠ꒿ Nuosuhxop" },
      { code: "nr", name: "South Ndebele", ename: "isiNdebele" },
      { code: "oc", name: "Occitan", ename: "Occitan" },
      { code: "oj", name: "Ojibwe, Ojibwa", ename: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
      {
        code: "cu",
        name: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
        ename: "ѩзыкъ словѣньскъ",
      },
      { code: "om", name: "Oromo", ename: "Afaan Oromoo" },
      { code: "or", name: "Oriya", ename: "ଓଡ଼ିଆ" },
      { code: "os", name: "Ossetian, Ossetic", ename: "ирон æвзаг" },
      { code: "pa", name: "Panjabi, Punjabi", ename: "ਪੰਜਾਬੀ, پنجابی‎" },
      { code: "pi", name: "Pāli", ename: "पाऴि" },
      { code: "fa", name: "Persian", ename: "فارسی" },
      { code: "pl", name: "Polish", ename: "polski" },
      { code: "ps", name: "Pashto, Pushto", ename: "پښتو" },
      { code: "pt", name: "Portuguese", ename: "Português" },
      { code: "qu", name: "Quechua", ename: "Runa Simi, Kichwa" },
      { code: "rm", name: "Romansh", ename: "rumantsch grischun" },
      { code: "rn", name: "Kirundi", ename: "kiRundi" },
      { code: "ro", name: "Romanian, Moldavian, Moldovan", ename: "română" },
      { code: "ru", name: "Russian", ename: "русский язык" },
      { code: "sa", name: "Sanskrit (Saṁskṛta)", ename: "संस्कृतम्" },
      { code: "sc", name: "Sardinian", ename: "sardu" },
      { code: "sd", name: "Sindhi", ename: "सिन्धी, سنڌي، سندھی‎" },
      { code: "se", name: "Northern Sami", ename: "Davvisámegiella" },
      { code: "sm", name: "Samoan", ename: "gagana faa Samoa" },
      { code: "sg", name: "Sango", ename: "yângâ tî sängö" },
      { code: "sr", name: "Serbian", ename: "српски језик" },
      { code: "gd", name: "Scottish Gaelic; Gaelic", ename: "Gàidhlig" },
      { code: "sn", name: "Shona", ename: "chiShona" },
      { code: "si", name: "Sinhala, Sinhalese", ename: "සිංහල" },
      { code: "sk", name: "Slovak", ename: "slovenčina" },
      { code: "sl", name: "Slovene", ename: "slovenščina" },
      { code: "so", name: "Somali", ename: "Soomaaliga, af Soomaali" },
      { code: "st", name: "Southern Sotho", ename: "Sesotho" },
      { code: "es", name: "Spanish; Castilian", ename: "español, castellano" },
      { code: "su", name: "Sundanese", ename: "Basa Sunda" },
      { code: "sw", name: "Swahili", ename: "Kiswahili" },
      { code: "ss", name: "Swati", ename: "SiSwati" },
      { code: "sv", name: "Swedish", ename: "svenska" },
      { code: "ta", name: "Tamil", ename: "தமிழ்" },
      { code: "te", name: "Telugu", ename: "తెలుగు" },
      { code: "tg", name: "Tajik", ename: "тоҷикӣ, toğikī, تاجیکی‎" },
      { code: "th", name: "Thai", ename: "ไทย" },
      { code: "ti", name: "Tigrinya", ename: "ትግርኛ" },
      {
        code: "bo",
        name: "Tibetan Standard, Tibetan, Central",
        ename: "བོད་ཡིག",
      },
      { code: "tk", name: "Turkmen", ename: "Türkmen, Түркмен" },
      { code: "tl", name: "Tagalog", ename: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔" },
      { code: "tn", name: "Tswana", ename: "Setswana" },
      { code: "to", name: "Tonga (Tonga Islands)", ename: "faka Tonga" },
      { code: "tr", name: "Turkish", ename: "Türkçe" },
      { code: "ts", name: "Tsonga", ename: "Xitsonga" },
      { code: "tt", name: "Tatar", ename: "татарча, tatarça, تاتارچا‎" },
      { code: "tw", name: "Twi", ename: "Twi" },
      { code: "ty", name: "Tahitian", ename: "Reo Tahiti" },
      { code: "ug", name: "Uighur, Uyghur", ename: "Uyƣurqə, ئۇيغۇرچە‎" },
      { code: "uk", name: "Ukrainian", ename: "українська" },
      { code: "ur", name: "Urdu", ename: "اردو" },
      { code: "uz", name: "Uzbek", ename: "zbek, Ўзбек, أۇزبېك‎" },
      { code: "ve", name: "Venda", ename: "Tshivenḓa" },
      { code: "vi", name: "Vietnamese", ename: "Tiếng Việt" },
      { code: "vo", name: "Volapük", ename: "Volapük" },
      { code: "wa", name: "Walloon", ename: "Walon" },
      { code: "cy", name: "Welsh", ename: "Cymraeg" },
      { code: "wo", name: "Wolof", ename: "Wollof" },
      { code: "fy", name: "Western Frisian", ename: "Frysk" },
      { code: "xh", name: "Xhosa", ename: "isiXhosa" },
      { code: "yi", name: "Yiddish", ename: "ייִדיש" },
      { code: "yo", name: "Yoruba", ename: "Yorùbá" },
      { code: "za", name: "Zhuang, Chuang", ename: "Saɯ cueŋƅ, Saw cuengh" },
    ],

    menu: [
      {
        id: "01",
        name: "Home",
        route: "Home",
        isActive: "",
      },
      {
        id: "02",
        name: "About Us",
        isActive: "",
      },
      {
        id: "03",
        name: "Our Journey",
        isActive: "",
      },
      {
        id: "04",
        name: "Our Journey",
        isActive: "",
      },
      {
        id: "04",
        name: "Products",
        route: "Product",
      },
      {
        id: "05",
        name: "Media",
        isActive: "",
      },
      {
        id: "06",
        name: "Investor's Relation",
        isActive: "",
      },
      {
        id: "07",
        name: "Blog",
        route: "",
        isActive: "",
      },
      {
        id: "08",
        name: "Events",
        route: "",
        isActive: "",
      },
      {
        id: "09",
        name: "Career",
        route: "Careers",
        isActive: "",
      },
      {
        id: "010",
        name: "Project",
        route: "",
        isActive: "",
      },
      {
        id: "011",
        name: "Connect",
        route: "",
        isActive: "",
      },
    ],
    selectedRoute: {
      name: "",
      isActive: "",
    },
    primaryLogo: "",
  }),
  methods: {
    googleTranslateElementInit() {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    },
    handleclick(name) {
      this.$router.push({ name: name });
      this.$refs.navbarRef.activeMenuResponsive = false;
      this.selectedRoute.name = name;
      this.isShowMenu = false;
      // const ind = this.menu.findIndex((x) => x.route === name);
      // console.log(ind);
      // if (ind >= 0) {
      //   this.menu[ind].isActive = true;
      // }
      // this.menu
      //   .filter((x) => x.route !== this.menu[ind].route)
      //   .map((x) => (x.isActive = false));
    },
    handleClick(name) {
      console.log(name, "url");
      this.$router.push({ name: name });

      this.isShowMenu = false;
    },
    hideTranslater() {
      this.isShowTranslater = false;
    },
    handleOpenTranslator() {
      this.isShowTranslater = true;
    },
    async getBrandProfile() {
      let payload = {
        projectId: process.env.VUE_APP_ID,
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      };
      let data = await this.$store.dispatch(
        "brandProfile/getBrandProfile",
        payload
      );
      this.getBrandProfileData = data.data;
      if (this.getBrandProfileData.length) {
        this.primaryLogo =
          `${process.env.VUE_APP_STORAGE_URL_2}` +
          this.getBrandProfileData[0].primaryLogo;
        // this.$store.commit(
        //   "brandProfile/UPDATE_PRIMARY_COLOR",
        //   this.getBrandProfileData[0].primaryColor
        // );
        this.$vs.theme({ primary: this.getBrandProfileData[0].primaryColor });
      }
    },
    async getAllMenuShow() {
      await this.$store.dispatch("menu/getAllClientMenu");
    },
    handleTranslate(lang) {
      console.log(lang);
    },
  },
  created() {
    const addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = this.googleTranslateElementInit;
  },
  destroyed() {
    const script = document.querySelector(
      'script[src*="translate.google.com/translate_a/element.js"]'
    );
    if (script && script.parentNode) {
      script.parentNode.removeChild(script);
    }
  },
  async mounted() {
    setTimeout(async () => {
      await this.getBrandProfile();
    }, 500);
    this.getAllMenuShow();
    await this.googleTranslateElementInit();
    // const ind = this.menu.findIndex((x) => x.route === this.activeRoute);

    // if (ind >= 0) {
    //   this.menu[ind].isActive = true;
    // }
    // this.menu
    //   .filter((x) => x.route !== this.menu[ind].route)
    //   .map((x) => (x.isActive = false));
  },

  computed: {
    activeRoute() {
      return this.$route.name;
    },

    ...mapState("auth", { user: "user" }),
    ...mapState("project", ["projectDetails"]),
    ...mapState("admin", ["getprojects"]),
    ...mapState("twoHerMenu", ["combinedMenuData"]),
    ...mapState("menu", ["menuData"]),
  },
  components: {
    MenuIcon,
    Translator,
    CGTranslator,
  },
};
</script>
<style lang="scss">
.el-collapse-item__header {
  @media (max-width: 640px) {
    line-height: 12px !important;
  }
}
.cust-bg-ff9137 {
  background: rgba(var(--vs-primary), 1) !important;
}
.cust-hover-none.btn-secondary:hover {
  background-color: none !important;
}
.vs-navbar--btn-responsive {
  display: none !important;
}
.navfontsize .el-collapse-item__header {
  font-size: 14px !important ;
  color: rgba(35, 35, 35, 0.5);
  font-weight: 600;
}
.productcolor .el-collapse-item__header {
  color: #b8b8b8 !important;
}
.cust-active-bg:active {
  background: rgba(var(--vs-secondary), 1) !important;
  color: white !important;
}
.el-collapse-item__header.is-active {
  background: rgba(var(--vs-secondary), 1) !important;
  color: white !important;
}
.vs-navbar--item a {
  // padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-left: 20px;
  padding-right: 20px;
}
.cust-bg-none.el-collapse-item__header {
  background: none;
  padding-left: 0px;
  padding-right: 0px;
}
.fontpx-5 .el-collapse-item__header {
  padding-left: 20px;
  padding-right: 0px;
}
.cust-font-hover:active {
  color: rgba(var(--vs-secondary), 1) !important;
}
.cust-border-bottom {
  border-bottom: 1px solid #e5e7eb;
}
.el-collapse {
  border-bottom: 0px solid !important;
}
.brdnone .el-collapse-item__content {
  padding-bottom: 0px !important;
}
.hovermenu:hover {
  background: rgba(var(--vs-secondary), 1) !important;
  color: white;
}
.nav-cust .eo__dropdown__menu {
  position: absolute;
  top: 120%;
  left: -36px;
}
@media (max-width: 768px) and (min-width: 641px) {
  .tab-nav-width .el-drawer__open .el-drawer.rtl {
    width: 30% !important;
  }
}

// @media (min-width: 992px) and (max-width: 768px) {
//   .desk-nav-width {
//     width: 20% !important;
//   }
// }
.fixanchr {
  padding: 0px !important;
  margin-top: 0px;
}
.fixanchr.vs-navbar--item a {
  padding-top: 0px !important;
}
.flag {
  display: none !important;
  visibility: hidden !important;
}
.icon-bdr {
  border-right: 1px solid gray;
  border-left: 1px solid gray;
  padding: 4px 10px;
}
@media (max-width: 640px) {
  .nav-cust .eo__dropdown__menu {
    position: absolute;
    top: 120%;
    left: -70px;
  }
}
</style>
